import { Component, OnChanges, OnInit, ViewEncapsulation } from '@angular/core';
import { FieldConfig } from '../../models/common-models';
import { UntypedFormGroup } from '@angular/forms';
import { DynamicFormService } from '../../service/dynamic-form.service';

@Component({
    selector: 'app-form-radio',
    templateUrl: './form-radio.component.html',
    styleUrls: ['./form-radio.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FormRadioComponent implements OnInit, OnChanges {
  config: FieldConfig;
  group: UntypedFormGroup; 
  constructor(public dfs:DynamicFormService) { }

  ngOnInit() {
    
    return;
  }
  ngOnChanges(){
   
    return;
  }
  selectedOption(event){
    if (this.config.cellClick){
      this.config.cellClick(event);
    }
    this.dfs.selectedRadioOption = event.value;
  }
}

